import { __assign } from "tslib";
import React, { useContext } from 'react';
import { getComponentName } from './helpers';
export var MobileContext = React.createContext(false);
MobileContext.displayName = 'MobileContext';
// HOC for convenience...
export function withMobileContext(Component) {
    var DecoratedComponent = function (props) {
        var isMobile = useContext(MobileContext);
        return React.createElement(Component, __assign({ isMobile: isMobile }, props));
    };
    DecoratedComponent.displayName = "withMobileContext(".concat(getComponentName(Component), ")");
    return DecoratedComponent;
}
//# sourceMappingURL=MobileContext.js.map